import type { IDisplayAdsFormatFilterDto } from "../../../types/leadsSearchFilters.dto";

export const FORMATS_KEYS: (keyof IDisplayAdsFormatFilterDto)[] = ["bannerShare", "nativeShare", "videoShare"];
